import React from 'react';
import type { VirtualGridOverlayApiT } from '../../../../common/virtual-grid';
import { FrameMarkerOverlay } from './frame-marker-overlay';
import { TimelineAutoScroll } from './timeline-autoscroll';
type TimelineOverlayPropsT = {
  totalFrames: number;
  cellWidth: number;
  overlayControls: VirtualGridOverlayApiT;
};

/**
 * Everything painted into the grid's overlay slot. Both children live here because the grid
 * only exposes its scroll API (`overlayControls`) to this slot: `TimelineAutoScroll` renders
 * null and just drives scrolling, while `FrameMarkerOverlay` renders the current-frame marker.
 */
export const TimelineOverlay = ({
  totalFrames,
  cellWidth,
  overlayControls
}: TimelineOverlayPropsT) => <>
    <TimelineAutoScroll overlayControls={overlayControls} totalFrames={totalFrames} />
    <FrameMarkerOverlay totalFrames={totalFrames} cellWidth={cellWidth} overlayControls={overlayControls} />
  </>;